<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="限定新用户">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">一码多用</el-radio>
          <el-radio :label="1">多码一用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="口令可使用数量" prop="count">
        <el-input v-model.number="form.count" placeholder="口令可使用数量" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item v-if="form.type === 0" label="暗号" prop="word">
        <el-input v-model="form.word" placeholder="暗号" :clearable="true"></el-input>
      </el-form-item>

      <el-form-item label="奖品名称" prop="giftName">
        <el-input v-model="form.giftName" placeholder="请输入奖品名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="礼品数量" prop="giftCount">
        <el-input v-model.number="form.giftCount" placeholder="礼品数量" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="奖品图标">
        <uploadImg v-model="form.giftIcon" :max="1" :text="['图片大小500kb以内']"></uploadImg>
      </el-form-item>
      <el-form-item label="限定新用户">
        <el-radio-group v-model="form.limitNewUser" @change="selectOption">
          <el-radio :label="0">不限定</el-radio>
          <el-radio :label="1">限定</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="form.giftType" @change="skuType">
          <el-radio :label="0">无奖品</el-radio>
          <el-radio :label="1">实体物品</el-radio>
          <el-radio :label="2">克拉数(如果选中克拉数,则你输入的数会被除于10000)</el-radio>
          <el-radio :label="3">优惠券</el-radio>
          <el-radio :label="4">经验值</el-radio>
          <el-radio :label="5">抽奖机会</el-radio>
          <el-radio :label="6">勋章</el-radio>
          <el-radio :label="7">属性值</el-radio>
          <el-radio :label="8">机会卷</el-radio>
          <el-radio :label="9">打卡任务</el-radio>
          <el-radio :label="10">委托卡片</el-radio>
          <el-radio style="margin-top:10px" :label="11">大赛资格</el-radio>
          <el-radio style="margin-top:10px" :label="12">地图资格</el-radio>
          <el-radio style="margin-top:10px" :label="14">成长币</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
          <input-value :value="form.giftValue" @update:value="form.giftValue = $event" :type="form.giftType == 14 ? 0:form.giftType" ></input-value>
      </el-form-item>
      <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
        <div v-for="(item, index) in form.thresholds" :key="index" style="margin-top: 20px;">
          <div style="margin-left: 20px;text-align: center;">门槛集合</div>
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker
              :disabled="item.timeLimit == 2 ? false :true"
              v-model="item.startLimitTime"
              type="datetime"
              placeholder="选择开始时间"
              @change="function(e){
              getStartLimitTime(e,index)
            }"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker
              :disabled="item.timeLimit == 2 ? false :true"
              v-model="item.endLimitTime"
              type="datetime"
              placeholder="选择结束时间"
              @change="function(e){
              getEndLimitTime(e,index)
            }"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="限定时间">
            <el-radio-group
              v-model="item.timeLimit"
              @change="function(e){
              getTimeLimit(e,index)
            }"
            >
              <el-radio :label="0">不限定</el-radio>
              <el-radio :label="1">活动期间</el-radio>
              <el-radio :label="2">指定时间</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="门槛类型">
            <el-radio-group v-model="item.type">
              <el-radio :label="1">绑定关系</el-radio>
              <el-radio :label="2">消费指定商品</el-radio>
              <el-radio :label="3">消费满N元</el-radio>
              <el-radio :label="4">消费满N单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="门槛值">
            <el-input
              v-model="item.value"
              placeholder="请输入门槛值"
              :clearable="true"
              :disabled="item.type == 1 ? true :false"
            ></el-input>
          </el-form-item>
          <div style="display: flex;justify-content: center;">
            <el-button type="primary" size="mini" @click="addThreshold">+增加门槛</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="removeThreshold(index)"
              v-if="index !== 0"
            >-删除门槛</el-button>
          </div>
        </div>
      </div>
      <el-form-item label="跳转地址" required>
        <jumpType2 :Jumpurls="form.Jumpurl"></jumpType2>
      </el-form-item>
      <el-form-item
        label="开始时间"
        prop="startTime"
        :rules="[
      {required: true, message: '请选择日期', trigger: 'change' }
    ]"
      >
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          placeholder="选择开始时间"
          @change="dataSearch"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="结束时间"
        prop="endTime"
        :rules="[
      {required: true, message: '请选择日期', trigger: 'change' }
    ]"
      >
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          placeholder="选择结束时间"
          @change="dataEnd"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <div class="tc" v-if="!editorialJudgment">
        <el-button type="primary" size="default" @click="seve('form')">确定</el-button>
        <el-button size="default" @click="closeFn">取消</el-button>
      </div>
      <div class="tc" v-if="editorialJudgment">
        <el-button @click="closeFn">取 消</el-button>
        <el-button type="primary" @click="getModify('form')">确 定</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import { getArrList } from '@/api/demo/discount/index'
import { getLuckList } from '@/api/demo/luckDraw/index'
import { getMedalList } from '@/api/demo/medal/index'
import { attList } from '@/api/demo/attributes/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
import { megagameList } from '@/api/demo/competition/index'
import {
  getCipherInfo,
  getCipherUpdate,
  getCipherDraw
} from '@/api/demo/command/index'
import { getMapList } from '@/api/demo/map'
import InputValue from '@/components/InputValue/index.vue'
import jumpType2 from '@/components/jumpType/jumpType.vue'
export default {
  name: 'addAndModifyADdd',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    jumpType2,
    InputValue,
    uploadImg
  },
  data () {
    return {
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [], // 打卡任务
      getCardList: [], // 卡片集合
      megagameList: [], // 大赛
      mapList: [], // 大赛
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] }
      ],
      form: {
        name: null, // 活动名称
        type: 0, // 0 一码多用 1 一码一用
        count: 0, // 口令可使用数量
        giftCount: 0, // 礼品数量
        giftIcon: null, // 奖品图标
        limitNewUser: 0, // 1 限定 0 不限定
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        giftName: null, // 奖品名称
        giftType: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会
        giftValue: '', // 虚拟物品值
        value2: '',
        Jumpurl: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        },
        skipUrl: '', // 跳转地址
        word: null, // 暗号
        thresholds: [
          {
            endLimitTime: null, // 限定时间: 结束时间
            startLimitTime: null, // 限定时间: 开始时间
            timeLimit: 0, // 限定时间: 0 不限定 1. 活动期间 2.指定时间
            type: 3, // 门槛类型: 1.绑定关系 2.消费指定商品 3.消费满N元 4.消费满N单
            value: 0 // 门槛值
          }
        ] // 门槛集合
      },
      editorialJudgment: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        word: [
          {
            required: true,
            message: '请输入暗号',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        giftCount: [
          { required: true, message: '礼品数量不能为空' },
          { type: 'number', message: '礼品数量必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        count: [
          { required: true, message: '口令可使用数量不能为空' },
          { type: 'number', message: '口令可使用数量必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        giftName: [
          {
            required: true,
            message: '请输入奖品名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.rewardId = that.$route.query.id
    that.true = that.$route.query.true
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getAttributes()
    that.getCRList()
    that.getThemesList()
    that.getMegagameList()
    that.getMapList()
    // console.log("dddd", that.rewardId);
    if (that.rewardId != undefined) {
      if (that.true == 'true') {
        that.getCipherInfo()
        that.editorialJudgment = false
      } else {
        that.getCipherInfo()
        that.editorialJudgment = true
      }
    } else if (that.rewardId == undefined) {
      that.editorialJudgment = false
    }
  },
  methods: {
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    getMapList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        classifyId: ''
      }
      getMapList(listQuery).then(res => {
        that.mapList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 100,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 卡片列表
    getCardsList (e) {
      let that = this
      getCard(e).then(res => {
        that.getCardList = res
      })
    },
    skusType (e) {
      // console.log("ee", e, index);
      let that = this
      if (e == '') {
      } else {
        that.form.giftValue = ''
        that.getCardsList(e)
      }
    },
    // 类型
    skuType (e) {
      let that = this
      that.form.giftType = e
      // console.log("index", this.form.gifts);
    },
    // 选项
    selectOption (e) {
      this.form.limitNewUser = e
    },
    // 开始时间
    dataSearch (e) {
      this.form.startTime = e
      // console.log("e", this.form.startTime);
    },
    // 结束时间
    dataEnd (e) {
      this.form.endTime = e
      // console.log("e", this.form.endTime);
    },
    // 新增门槛
    addThreshold () {
      this.form.thresholds.push({
        endLimitTime: null, // 限定时间: 结束时间
        startLimitTime: null, // 限定时间: 开始时间
        timeLimit: 0, // 限定时间: 0 不限定 1. 活动期间 2.指定时间
        type: 1, // 门槛类型: 1.绑定关系 2.消费指定商品 3.消费满N元 4.消费满N单
        value: 0 // 门槛值
      })
    },
    // 删除门槛
    removeThreshold (index) {
      this.form.thresholds.splice(index, 1)
      this.form.thresholds.forEach((item, index) => {
        item.index = index
      })
    },
    // 详情
    getCipherInfo () {
      let that = this
      getCipherInfo(that.rewardId).then(res => {
        that.form = res
        that.form.Jumpurl = JSON.parse(res.skipJson)
      })
    },
    // 新增
    seve (form) {
      let that = this
      // that.form.giftIcon = that.form.giftIcon2.join();
      console.log('that.form', that.form)
      that.form.skipUrl = that.form.Jumpurl.url
      that.form.skipJson = JSON.stringify(that.form.Jumpurl)
      if (that.form.startTime == null || that.form.endTime == null) {
        that.$notify({
          title: '警告',
          message: '开始时间和结束不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }
      that.$refs[form].validate(valid => {
        if (valid) {
          this.loading = this.$loading({
            lock: true,
            text: '正在保存...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getCipherDraw(that.form).then(res => {
            that.loading.close()
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/command'
            })
          }).catch(err => {
            that.loading.close()
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 返回
    closeFn () {
      let that = this
      that.$router.push({
        path: '/demo/command'
      })
    },
    getModify (form) {
      let that = this
      console.log('that.form', that.form)
      that.form.skipUrl = that.form.Jumpurl.url
      that.form.skipJson = JSON.stringify(that.form.Jumpurl)
      if (that.form.startTime == null || that.form.endTime == null) {
        that.$notify({
          title: '警告',
          message: '开始时间和结束不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }

      that.$refs[form].validate(valid => {
        if (valid) {
          this.loading = this.$loading({
            lock: true,
            text: '正在更新...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          getCipherUpdate(that.form, that.rewardId).then(res => {
            this.loading.close()
            that.$notify({
              title: '成功',
              message: '编辑成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/command'
            })
          }).catch(err => {
            this.loading.close()
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    }
  }
}
</script>
<style  scoped>
.tc {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
